class StorageFileModel {
  fileName: string = "";
  displayName: string = "";
  fileUri?: string;
}

export default StorageFileModel;